import { Graph } from "@antv/x6"
import { getGraphSvg, intervalToPromise, timeoutToPromise } from "../utils"
import { Provider as ReduxProvider } from 'react-redux'

import ReactDOM from 'react-dom/client';
import { createRef, useCallback } from "react"
import { EditorGraph } from "../EditorGraph"
import { XFlow } from "@antv/xflow"
import { store } from "@/store"
import { FlowTemplate } from "../components/Template/Template"

export const usePrintContent = () => {
  return useCallback(async (sheet, template): Promise<string> => {
    const ref = createRef<any>()
    const container = document.createElement('div')
    container.setAttribute('style', 'visibility:hidden;width:1000px;height:1000px;')
    const root = ReactDOM.createRoot(
      container
    );
    root.render(
      <ReduxProvider store={store}>
        <XFlow>
          <EditorGraph content={sheet} template={template} ref={ref} />
          <FlowTemplate />
        </XFlow>
      </ReduxProvider>
    )
    
    const curGraph = await intervalToPromise(() => {
      const graph = ref.current.getGraph()
      return Promise.resolve(graph)
    }, 100)

    return timeoutToPromise(() => {
      return getGraphSvg(curGraph as Graph)
    }, 1000) as any
  }, [])
}